import PropTypes from "prop-types";
import React from "react";
import { Redirect } from "react-router-dom";
import { parse } from "util/query-string";

class RedirectView extends React.PureComponent {
  static get propTypes() {
    return {
      location: PropTypes.object.isRequired,
    };
  }

  render() {
    const { location } = this.props;
    const { search } = location;
    const params = parse(search);
    const { to: pathname } = params;

    if (pathname) {
      return <Redirect to={pathname} />;
    }

    console.error(
      'Error: Only redirect to this view with "to" parameter in ' +
        "query string.",
    );

    return <Redirect to="/404" />;
  }
}

export { RedirectView };
